import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ca84a7b6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca84a7b6')) {
      api.createRecord('ca84a7b6', component.options)
    } else {
      api.reload('ca84a7b6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ca84a7b6", function () {
      api.rerender('ca84a7b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Ueditor/index.vue"
export default component.exports